"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = exports.baseColors = void 0;
exports.baseColors = {
    white: '#fff',
    black: '#000',
    gray: [
        '#fff',
        '#E1E1E1',
        '#EBEFF0',
        '#DDE5E7',
        '#EBEBEB',
        '#DDDDDD',
        '#F4F4F4',
    ],
};
exports.colors = {
    primary: '#3E736D',
    secondary: '#888888',
    mainRed: '#E30613',
    redSecondary: '#FC5F62',
    interactionRed: '#C20000',
    interactionPrimary: '#23423E',
    accentColor: '#BFE8DE',
    accentColorBg: '#DCE4EF',
    lightGreen: '#D6F0C9',
    lightMint: '#ECF1F0',
    lightBlue: '#CCE3FA',
    lightYellow: '#F2EBA6',
    lightGreyFirst: exports.baseColors.gray[1],
    lightGreySecond: exports.baseColors.gray[2],
    lightGreyThird: exports.baseColors.gray[3],
    lightGreyFourth: exports.baseColors.gray[4],
    lightGreyFifth: '#E2E6E7',
    lightGreySixth: exports.baseColors.gray[6],
    lightGreySeventh: '#E4E5E9',
    borderGreyFifth: exports.baseColors.gray[5],
    borderColor: exports.baseColors.gray[1],
    darkGray: '#4E4E4F',
    darkRed: '#CC0000',
    white: exports.baseColors.white,
    bgInput: exports.baseColors.white,
    borderInput: exports.baseColors.gray[1],
    background: exports.baseColors.white,
    markupForm: exports.baseColors.white,
    backgroundGrey: exports.baseColors.gray[3],
    bgMenuLinks: exports.baseColors.white,
    bgLightBlue: exports.baseColors.gray[2],
    bgMediumBlue: '#D4DBDC',
    bgDarkBlue: '#7FA8B7',
    bgDarkBlueSecond: '#046B99',
    bgLightGrey: exports.baseColors.gray[6],
    warning: '#F9C642',
    bgWarning: '#FFF1D2',
    success: '#2E8540',
    successBg: '#E7F4E4',
    error: '#CD2026',
    defaultText: exports.baseColors.black,
    facebookButtonBackground: '#3B5998',
    facebookIconBackground: '#263C68',
    googleButtonBackground: '#F44336',
    googleIconBackground: '#C53126',
    modalShadow: 'rgba(0, 0, 0, 0.7)',
    authModalBackgroundColor: exports.baseColors.white,
    pinWrapper: '#4E4E4F',
    activePinWrapper: '#3E736D',
    borderSkeleton: '#F5F6F7',
    bgError: '#F9DEDE',
    linkUnderlineColor: 'rgba(0, 0, 0, 0.3)',
    linkUnderlineColorWhite: 'rgba(255, 255, 255, 0.3)',
};
//# sourceMappingURL=colors.js.map